import styled from 'styled-components';
import { useState } from "react";
import { ChevronIcon, Field, Label } from '../../../../components/Forms';
import { Select } from "../../../../components/Select";
import { getArtigos, mapSelectAlinea, mapSelectArtigos, mapSelectInciso, mapSelectParagrafo } from '../../../../hooks/useLDA';
import { useLocation, useNavigate } from "react-router-dom";

export function Form() {
  const history = useNavigate();
  let version = '';
  const location = useLocation();
  try {
    version = location.pathname.split('/')[2] || '';
  } catch (e) {}

  const [artigo, setArtigo] = useState('');
  const selectArtigos = mapSelectArtigos();
  const [paragrafo, setParagrafo] = useState('');
  const [inciso, setInciso] = useState('');
  const [alinea, setAlinea] = useState('');

  let optionsParagrafo = [<option value=''>Selecionar</option>];
  let optionsInciso = [<option value=''>Selecionar</option>];
  let optionsAlinea = [<option value=''>Selecionar</option>];
  
  if (artigo) {
    optionsParagrafo = optionsParagrafo.concat(mapSelectParagrafo(artigo).map((key: any) => <option id={JSON.stringify(key)} value={JSON.stringify(key)}>{`${key?.history?.split('#').pop()}`.replace('_val', '')}</option>));
    optionsInciso = optionsInciso.concat(mapSelectInciso(artigo).map((key: any) => <option id={JSON.stringify(key)} value={JSON.stringify(key)}>{`${key?.history?.split('#').pop()}`.replace('_val', '')}</option>));
    optionsAlinea = optionsAlinea.concat(mapSelectAlinea(artigo).map((key: any) => <option id={JSON.stringify(key)} value={JSON.stringify(key)}>{`${key?.history?.split('#').pop()}`.replace('_val', '')}</option>));
  }


  async function useSubmit(e: any) {
    e.preventDefault();
    // console.log(version)
    // console.log('pathname')
    // console.log(location.pathname)
    version = version? `/${version.toLowerCase()}` : ''
    if (!artigo) return;

    const data = {
      artigo: JSON.stringify({...(getArtigos() as any)[artigo], history: `#${artigo}#`} ),
      paragrafo,
      inciso,
      alinea
    }
    try {
      console.log("===")
      console.log(Object.entries(data).map(([key, value]) => {
        if(!value) return `${key}: `
        return `${key}: ${JSON.parse(value)?.history}`
      }))
      console.log("===")
    } catch (error) {}
    history(
      `/lda${version}/result`, 
      {
        state: {
          data
        }
      }
    ); 
  }


  return (
    <Content onSubmit={useSubmit}>
      <Label>Artigo</Label>
      <Field marginBottom="16px">
        <Select 
          value={artigo} 
          onChange={(value: any) => setArtigo(value)}
        >
          <option value={''}>Selecionar</option>
          {selectArtigos.map((key) => (
            <option value={key}>{key.replace('_val', '')}</option> 
          ))}
        </Select>
        <ChevronIcon size={24} />
      </Field>
      <Label>Parágrafo</Label>
      <Field marginBottom="16px">
      <Select 
          value={paragrafo} 
          onChange={(value) => setParagrafo(value)}
          // disabled={!artigo}
        >
          {optionsParagrafo}
        </Select>
        <ChevronIcon size={24} />
      </Field>
      <Label>Inciso</Label>
      <Field marginBottom="16px">
      <Select 
          value={inciso} 
          onChange={(value: any) => setInciso(value)}
          // disabled={!artigo}
        >
          {optionsInciso}
        </Select>
        <ChevronIcon size={24} />
      </Field>
      <Label>Alínea</Label>
      <Field marginBottom="16px">
      <Select 
          value={alinea} 
          onChange={(value: any) => setAlinea(value)}
          // disabled={!artigo}
        >
          {optionsAlinea}
        </Select>
        <ChevronIcon size={24} />
      </Field>
      <Button>Pesquisa</Button>
    </Content>
  );
}

const Content = styled.form`
  flex: 9;
  padding-left: 64px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 0 12px 48px;
  }
`;

const Button = styled.button`
  display: inline-block;
  background-color: #fff;
  color: ${({ theme }) => theme.colors.blue.dark};
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
  height: 72px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  margin-top: 32px;
  border: ${({ theme }) => `2px solid ${theme.colors.gray.darker}`};
  cursor: pointer;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    position: static;
    width: 100%;
    max-width: 100%;
    height: 54px;
    font-size: 20px;
    margin-top: 12px;
  }
`;